import { useSelector } from 'react-redux';
import { getCookieByName } from '../utils/functions';

export function useEnablePDWeb(showPDWeb?: boolean) {
  const enablePDWebCookie = getCookieByName('enablePDWeb', true);

  const enablePDWebConfig = useSelector(
    (state: any) => state.config?.prescriptionModule?.enablePDWeb
  );
  const enablePDWebFlow = useSelector(
    (state: any) => state?.workflow?.flowDefiningAttributes?.showPDWeb
  );

  if (enablePDWebCookie !== null && enablePDWebCookie !== undefined) {
    return enablePDWebCookie as boolean;
  }
  if (enablePDWebConfig !== null && enablePDWebConfig !== undefined) {
    return enablePDWebConfig as boolean;
  }
  if (
    (enablePDWebFlow !== null &&
      enablePDWebFlow !== undefined &&
      enablePDWebFlow !== false) ||
    showPDWeb
  ) {
    return true;
  }
  return false;
}
